import React from "react";
import PropTypes from "prop-types";
import { blue, red, yellow } from "@mui/material/colors";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ErrorIcon from "@mui/icons-material/Error";
const MessageTypeIcon = (props) => {
  const { messageType } = props;
  const icons = {
    info: /* @__PURE__ */ React.createElement(InfoIcon, { style: { color: blue[500] } }),
    warning: /* @__PURE__ */ React.createElement(WarningIcon, { style: { color: yellow[500] } }),
    error: /* @__PURE__ */ React.createElement(ErrorOutlineIcon, { style: { color: red[500] } }),
    emergency: /* @__PURE__ */ React.createElement(ErrorIcon, { style: { color: red[500] } })
  };
  return icons[messageType] ?? messageType;
};
MessageTypeIcon.propTypes = {
  messageType: PropTypes.string
};
export default MessageTypeIcon;
